<form
    #form
    fsForm
    [submit]="save"
    *fsSkeletonForm="environmentCreate">
  <mat-card-content>
    <h1>
      What is the first project your team will work on?
    </h1>
    <mat-form-field class="full-width">
      <mat-label>
        Project Name
      </mat-label>
      <input
        matInput
        [(ngModel)]="environmentCreate.projectName"
        fsFormRequired
        name="project_name">
    </mat-form-field>
  </mat-card-content>
  <mat-card-actions>
    <button
        type="submit"
        mat-flat-button
        color="primary"
        class="full-width">
      Continue
    </button>
  </mat-card-actions>
</form>